import { getDevices } from '@web-ui-kit/hooks.use-media-query'
import { styled } from 'styled-components'

const { MEDIUM } = getDevices()

export const Container = styled.div`
  background-color: inherit;
  max-width: 42rem;
  width: 80vw;
  @media (${MEDIUM}) {
    min-width: 35rem;
    width: auto;
  }
`
